import { render, staticRenderFns } from "./RecuclerCityList.vue?vue&type=template&id=650ffe42&"
import script from "./RecuclerCityList.vue?vue&type=script&lang=ts&"
export * from "./RecuclerCityList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports